var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "page-loading"
  }, [_c('Popup', {
    attrs: {
      "modal": true,
      "container-style": {
        'background-color': 'transparent'
      },
      "position": "center"
    },
    model: {
      value: _vm.spinnerVisible,
      callback: function callback($$v) {
        _vm.spinnerVisible = $$v;
      },
      expression: "spinnerVisible"
    }
  }, [_c('div', {
    staticClass: "ro-indicator-wrap dark"
  }, [_c('div', {
    staticClass: "ro-indicator"
  }, [_c('DaisySpinner', {
    staticClass: "normal light"
  })], 1)])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };